import { RadarIcon, CheckCircle2 } from "lucide-react";

const POINTS = [
  "AI-scored UK public-sector contracts, ranked for your team",
  "Bid pipeline, submission checklists & renewal intelligence",
  "A confident AI bid writer trained on winning tenders",
];

export function AuthLayout({ children }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-zinc-100">
      {/* Brand panel */}
      <div className="hidden lg:flex flex-col justify-between bg-[#14304F] text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "22px 22px" }} />
        <div className="relative">
          <div className="flex items-center gap-3">
            <img src="/cph-mark.png" alt="CPH" className="h-12 w-12 object-contain bg-white p-1" />
            <div className="border-l border-white/20 pl-3">
              <div className="font-display font-extrabold text-xl tracking-tight">CPH</div>
              <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#4F9BDC] font-bold">Contract Intelligence</div>
            </div>
          </div>
        </div>
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold tracking-tighter leading-tight mb-6">
            Win more public-sector work.
          </h2>
          <ul className="space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-zinc-200">
                <CheckCircle2 size={18} className="text-[#4F9BDC] shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative text-[11px] font-mono uppercase tracking-[0.15em] text-white/40">
          UK & British Isles · Public Sector Contracts
        </div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-2 mb-8 justify-center">
            <RadarIcon size={22} className="text-[#2F6DA3]" />
            <span className="font-display font-extrabold text-lg tracking-tight text-[#14304F]">CPH Contract Intelligence</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
